// extracted by mini-css-extract-plugin
export default {"cls1":"PostEngagementFollowPrompt-cls1__eba890a8d48d145248ee","cls2":"PostEngagementFollowPrompt-cls2___3d640ef1c26e8dba2fd PostEngagementFollowPrompt-cls1__eba890a8d48d145248ee"};